<template>
<div id="app">
    <router-view></router-view>
</div>
</template>

<script>
export default {
    name: "App",
    created() {
        this.$store.dispatch("checkSession");
		this.$store.dispatch("loadInvestorUnreadTickets");
    },
};
</script>

<style lang="css">
@import '../node_modules/video.js/dist/video-js.min.css';
</style>

<style lang="less">
@import '@/assets/less/style.less';
</style>
